import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';

import './dashboard.css';

class DashboardPage extends React.Component {
    render() {
        return (
            <div className="row dashboard">
                <div className="col-xs-12">
                    <TenantManager {...tenants} {...this.props} />
                </div>
            </div>
        );
    }
}

DashboardPage.meta = {
    label: <FormattedMessage id={'dashboard'} defaultMessage={'Dashboard'} />,
    icon: 'dashboard',
    action: () => history.push('/dashboard'),
    locations: ['/dashboard', '/']
};

DashboardPage.defaultProps = {
    user: {}
};

DashboardPage.propTypes = {
    user: PropTypes.object
};

const mapStateToProps = state => ({
    user: state.identity.profile
});

export default connect(mapStateToProps, null)(DashboardPage);



// WEBPACK FOOTER //
// ./src/pages/dashboard/index.jsx